import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbsUp as faSolidThumbsUp } from '@fortawesome/free-solid-svg-icons';
import { faThumbsUp } from '@fortawesome/free-regular-svg-icons';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { setVoice } from '../../../slices/client-voices-slice';
import { getStartDateFromProgram, isNowBeforeDate } from '../../../util/dates';

export function ProgramRequestLike(props) {
    const { requestId } = props;
    const [liked, program] = useSelector(state => [
        state.clientVoices.voices[requestId] || false,
        state.program.program
    ]);
    const dispath = useDispatch();
    const icon = liked ? faSolidThumbsUp : faThumbsUp;
    const iconColorClass = liked ? 'text-info' : 'text-secondary';
    const handleLike = useCallback(
        evt => {
            evt.preventDefault();
            evt.stopPropagation();
            if (isNowBeforeDate(getStartDateFromProgram(program))) {
                toast.warn('Пока еще не время голосовать за выступление!');
                return;
            }
            dispath(setVoice({ requestId, liked: !liked }));
        },
        [dispath, liked, program, requestId]
    );
    return (
        <Button
            variant="link"
            className={`icon-button ${iconColorClass}`}
            size="sm"
            title="Нравится!"
            onClick={handleLike}
        >
            <FontAwesomeIcon icon={icon} size="1x" />
        </Button>
    );
}
